import type { ParallaxSvgSpec } from '../../../../config/atmosphere/effectLayer.types';
import { placeWorldShape, type ShapePlacement } from './worldShapeKit';

/** Existing tree and stone vocabulary, composed once at matching display scale.
 * Shallow banks and separated landmarks leave the upper routes open. */
function depth(height: number, shapes: readonly ShapePlacement[]): ParallaxSvgSpec {
  const bank = `M0 ${height}V${height - 80}Q240 ${height - 96} 480 ${height - 82}`
    + `T960 ${height - 82}T1440 ${height - 82}T1920 ${height - 82}Q2160 ${height - 72} 2400 ${height - 80}V${height}Z`;
  return { tile: { viewBoxWidth: 2400, viewBoxHeight: height,
    path: [bank, ...shapes.map(shape => placeWorldShape(...shape))].join(' ') } };
}

export const REGIONAL_DEPTH_HEIGHTS = {
  amber_grove: 1152, sakura_vale: 1080, smoldering_wastes: 1320, stoneveil_barrens: 1000,
} as const;

export const REGIONAL_DEPTH_BACKDROPS = {
  amber_grove: depth(1152, [
    ['maple', 140, 1152, 620, 1100], ['maple', 1160, 1152, 530, 960],
    ['oak', 1970, 1152, 380, 680],
  ]),
  sakura_vale: depth(1080, [
    ['blossom', 100, 1080, 640, 950], ['blossom', 1180, 1080, 560, 860],
    ['mountain', 1960, 1080, 360, 300],
  ]),
  smoldering_wastes: depth(1320, [
    ['basalt', 140, 1320, 280, 1160], ['volcano', 760, 1320, 520, 490],
    ['basalt', 1420, 1320, 340, 1080],
  ]),
  stoneveil_barrens: depth(1000, [
    ['mesa', 160, 1000, 480, 820], ['obelisk', 1100, 1000, 100, 880],
    ['snag', 1780, 1000, 170, 700],
  ]),
} satisfies Record<keyof typeof REGIONAL_DEPTH_HEIGHTS, ParallaxSvgSpec>;
